import {
  Accordion,
  AccordionSummary,
  LinearProgress,
  Pagination,
  PaginationItem,
} from "@mui/material";
import { connect } from "react-redux";
import {
  ArrowBack,
  Cancel,
  Forward,
  PersonalCard,
  Prerenderbg2,
} from "../../../assets";
import {
  Button,
  CustomModal,
  EmptyTable,
  Input,
  Layout,
  TableRowResponsive,
} from "../../components";
import { TransactionController } from "../../controllers";
import { Helmet } from "react-helmet-async";
import { numberWithCommas } from "../../../core/utils";
import CreatInput from "../../components/creat_input";
function CustomInput({ onFocus, value, onChange, title, emptyState }: any) {
  return (
    <>
      <Input
        customFocus={onFocus}
        myStyle="w-100"
        title={title}
        value={value}
        onChange={onChange}
        emptyState={emptyState}
      />
    </>
  );
}
class Transaction extends TransactionController {
  componentDidMount() {
    window.scrollTo(0, 0);
    this.getList();
  }
  render() {
    const {
      shareList,
      loading,
      clickLoading,
      openModal,
      shareHolder,
      price,
      str,
    } = this.state;
    return (
      <Layout title="تراکنش ها">
        <Helmet>
          <title> تراکنش ها / بیمه زندگی هامرز</title>
        </Helmet>
        {loading ? (
          <LinearProgress />
        ) : (
          <>
            <div className="policy-filter">
              {/*  */}

              <CreatInput
                title="تادیه"
                placeholder="پرداخت تادیه"
                onClick={() => this.setState({ openModal: !openModal })}
                str={str}
                buttonTitle="واریز تادیه"
                loadingContent={loading}
              />
            </div>

            <div className="policy table-responsive scrollbar offers">
              <table className="table hide-mobile">
                <thead>
                  <tr>
                    <th scope="col">ردیف</th>
                    <th scope="col">مبلغ </th>
                    <th scope="col">تعداد سهم</th>
                    <th scope="col">تاریخ</th>
                  </tr>
                </thead>
                <tbody>
                  {shareList?.list?.length > 0 &&
                    shareList?.list?.map((item: any, index: number) => {
                      return (
                        <tr>
                          <th>{index + 1}</th>
                          <th>{numberWithCommas(item?.deposit_amount) || "----"}</th>
                          <td>{item?.stock_amount || "----"} </td>
                          <td>{item?.date || "----"} </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              {shareList?.list?.length > 0 ? (
                <>
                  {shareList?.list?.map((item: any, index: number) => {
                    return (
                      <Accordion expanded={false} className="policy-accordion hide-desktop">
                        <AccordionSummary
                          aria-controls="panel1a-content"
                          className="summsry"
                          id="panel1a-header"
                        >
                          <TableRowResponsive title="ردیف" value={index + 1} />
                          <TableRowResponsive
                            title=" مبلغ "
                            value={numberWithCommas(item?.deposit_amount)|| "----"}
                          />
                          <TableRowResponsive
                            title="تعداد سهم"
                            value={item?.stock_amount || "----"}
                          />
                          <TableRowResponsive
                            title="تاریخ"
                            value={item?.date || "----"}
                          />
                        </AccordionSummary>
                      </Accordion>
                    );
                  })}

                  <Pagination
                    className="custom-pagination"
                    count={
                      shareList?.total ? Math.ceil(shareList?.total / 10) : 1
                    }
                    page={shareList?.page_number}
                    onChange={this.handleChangePage}
                    size="small"
                    renderItem={(item) => (
                      <PaginationItem
                        slots={{ previous: Forward, next: ArrowBack }}
                        {...item}
                      />
                    )}
                  />
                </>
              ) : (
                <EmptyTable title="   تراکنشی ثبت نشده است " />
              )}
            </div>

            <CustomModal
              myStyle="vertical-content-modal"
              openModal={openModal}
              onClose={() => this.setState({ openModal: !openModal })}
            >
              <>
                <div className="custom-modal-main-title hide-desktop ">
                  <h1 className="title"> واریز تادیه </h1>
                  <Cancel
                    myStyle="ps-2 "
                    width="20"
                    height="20"
                    color="#000000"
                    onClick={() => this.setState({ openModal: !openModal })}
                  />
                </div>
                <div className="filter-selected">
                  <div>
                    <span className="text ml-50 hide-mobile bold">
                      {" "}
                      واریز تادیه{" "}
                    </span>{" "}
                  </div>
                  <Cancel
                    myStyle="hide-mobile cursor-pointer"
                    onClick={() => this.setState({ openModal: !openModal })}
                  />
                </div>
                <img src={Prerenderbg2} alt="هامرز" className="W-100 image" />
                <div className="info-group">
                  <span className="pre-payment-title">
                    لطفا تعداد سهم را وارد کنید.
                  </span>

                  <div className="w-100 mt-33 mb-5">
                    <Input
                      hideEndAdornment
                      type="number"
                      myStyle="w-100"
                      title="تعداد سهم"
                      value={shareHolder}
                      onChange={this.handleChangeShareHolder}
                      icon={<PersonalCard />}
                    />

                    <Input
                      hideEndAdornment
                      type="number"
                      disabled
                      myStyle="w-100"
                      title="مبلغ به ریال"
                      value={numberWithCommas(price) ?? ""}
                      icon={<PersonalCard />}
                    />
                  </div>

                  <div className="d-flex justify-content-end w-100">
                    <Button
                      myStyle="bg-blue pre-payment-btn"
                      title="پرداخت"
                      disabled={!price}
                      onClick={() => this.create()}
                      loading={clickLoading}
                    />
                  </div>
                </div>
              </>
            </CustomModal>
          </>
        )}
      </Layout>
    );
  }
}

const mapStateToProps = (dispatch: any) => {
  return {
    dispatch,
    dashboardData: dispatch.general.dashboardData,
  };
};

export default connect(mapStateToProps)(Transaction);
